export default () => {
    // Store Locator 
    window.addEventListener('infoWindowOpen', ev => {
        let infoWindow;
        const myInterval = setInterval(() => {
          infoWindow = ev.detail.content;
          if (infoWindow) {
            let infoDetails = infoWindow.querySelector('details');
            infoDetails.classList.add('open'); 
            clearInterval(myInterval);
            infoDetails.open = true;
          }
        }, 50);
      }); 
    
      
      const poiList = document.querySelector('jump-poilist');
      if (poiList) {
        poiList.componentOnReady().then( element => {
          element.querySelectorAll('jump-poimap-place').forEach(item => {
            item.querySelector('details').addEventListener('click', ev => {
              poiList.querySelectorAll('details').forEach(detail => { 
                if (ev.srcElement.parentElement !== detail) { 
                  detail.open = false;
                }
              });
            });
          });
        })
      } 
    // Fine Store Locator
}